import BaseComponent from "@js/components/base_component.jsx";

import EuiRoutesForm from "@js/components/eui/routes/form.jsx";

class EuiRoutesShow extends BaseComponent {

  render() {
    return (
      <EuiRoutesForm { ...this.props } editing={ false } />
    );
  }

}

export default EuiRoutesShow;
